// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import $eventBus from './mixins/event-bus'
import $http from './mixins/http'
import store from './store'
import routes from './router/routes'
import common from './mixins/common'
import VueLodash from "vue-lodash";
import findIndex from 'lodash/findIndex';

Vue.config.productionTip = false;
Vue.config.silent = true;
Vue.prototype.$http = $http;
Vue.prototype.$eventBus = $eventBus;

Vue.config.devtools = true;
if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false;
}
Vue.use(VueRouter);
Vue.use(common);
Vue.use(VueLodash, { name: 'custom',
  lodash:
    {
      findIndex
    }
});


// Routing logic0
const router = new VueRouter({
  routes: routes,
  mode: 'history'
});

new Vue({
  el: '#vue_wrap',
  router: router,
  store: store,
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js